// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0ea6d25","638":"e2baee9c","668":"c3b5aa9b","984":"54de2b37"}[chunkId] + ".chunk.js";
};